/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Versions_EmptyInputs */



/**
* | output |
* | --- |
* | "No saved versions yet. A version is recorded the next time the app is changed." |
*
* @param {Canvas_Versions_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_empty = /** @type {((inputs?: Canvas_Versions_EmptyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_EmptyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Noch keine gespeicherten Versionen. Eine Version wird bei der nächsten Änderung der App angelegt.")
	return /** @type {LocalizedString} */ ("No saved versions yet. A version is recorded the next time the app is changed.")
});